import type { QueryFunction } from 'common/queryFunction';
import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';

import { getAccountQueryKey } from './keys';
import type { AccountData, UseAccountParams } from './types';

export const useAccount: QueryFunction<
  AccountData,
  [UseAccountParams],
  ReturnType<typeof getAccountQueryKey>
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getAccountQueryKey(params);
  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/accounts/${params.accountId}`, {
        init: {
          signal,
        },
      }),
  });
};
